import { render, staticRenderFns } from "./ChipsTags.vue?vue&type=template&id=a3c8ec2c&scoped=true&"
import script from "./ChipsTags.vue?vue&type=script&lang=js&"
export * from "./ChipsTags.vue?vue&type=script&lang=js&"
import style0 from "./ChipsTags.vue?vue&type=style&index=0&id=a3c8ec2c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c8ec2c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VChipGroup } from 'vuetify/lib/components/VChipGroup';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VBtn,VChipGroup,VToolbar})
